<template>
  <div class="vehicle-detail-page">
    <!-- 地图容器 -->
    <div class="map-container" id="monitor-map-container">
      <div ref="mapContainer" class="map-wrapper"></div>
      
      <!-- 地图左上角的路线信息区域 -->
      <div class="vehicle-testing-detail">
        <div class="route-info-panel">
          <!-- 展开/收起按钮 -->
          <div class="panel-close-btn" @click="toggleRouteDetails">
            {{ isRouteDetailsExpanded ? '−' : '+' }}
          </div>
          <!-- 路线标题和总时长 -->
          <div class="route-header">
            <div class="route-title">
              <div class="arrow-section">
                <div class="route-arrow">↓</div>
              </div>
              <div class="points-section">
                <div class="point-item">
                  <span class="point-label">起</span>
                  <span class="point-name">{{ testingRoutesInfo[0]?.origin || '暂无起点' }}</span>
                </div>
                <div class="point-item">
                  <span class="point-label">终</span>
                  <span class="point-name">{{ testingRoutesInfo[0]?.destination || '暂无终点' }}</span>
                </div>
              </div>
            </div>
            <div class="route-duration">
              <span class="duration-label">里程</span>
              <span class="duration-value">{{ testingRoutesInfo[0]?.distance || '0' }}公里</span>
            </div>
          </div>
          
          <!-- 路线详情列表 -->
          <div class="route-details" v-show="isRouteDetailsExpanded">
            <!-- 统计信息 -->
            <div class="events-stats">
              <div class="stat-item">
                <span class="stat-label">路线途径点</span>
              </div>
            </div>
            
            <!-- 途经点列表 -->
            <div class="events-list">
              <div 
                v-for="(order, index) in businessOrders" 
                :key="index"
                class="event-item"
              >
                <div class="event-timeline">
                  <div class="timeline-dot dot-blue"></div>
                  <div v-if="index < businessOrders.length - 1" class="timeline-line"></div>
                </div>
                <div class="event-content">
                  <div class="event-row">
                    <span class="event-stop-name">{{ order.stopName || '-' }}</span>
                    <span class="event-status">{{ order.orderStatusName || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vehicle-info-top-right">
        <!-- 测试牌照和返回按钮 -->
        <div class="info-section info-section-header">
          <div class="license-plate-highlight">
            <span class="license-number">{{ testingVehicleInfo?.licenceNo }}</span>
          </div>
          <div class="battery-display">
            <span class="battery-icon">🔋</span>
            <span class="battery-value">{{ testingVehicleInfo?.batteryLevel ?? '-' }}%</span>
          </div>
          <div class="back-button" @click="goBack">
            <img src="@/assets/icons/back.png" class="back-icon" alt="返回">
          </div>
        </div>
        <!-- 车辆识别信息 -->
        <div class="info-section info-section-details">
          <div class="detail-item">
            <span class="detail-label">识别编码:</span>
            <span class="detail-value">{{ testingVehicleInfo?.vehicleVin || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">主体:</span>
            <span class="detail-value">{{ testingVehicleInfo?.deptName || '-' }}</span>
          </div>
          <!-- 安全员和驾驶员信息 -->
          <template v-if="testingVehicleInfo?.securityUsers && testingVehicleInfo.securityUsers.length > 0">
            <div v-for="securityUser in testingVehicleInfo.securityUsers" :key="securityUser.id" class="detail-item">
              <span class="detail-label">{{ securityUser.type === 'security' ? '安全员' : securityUser.type === 'driver' ? '驾驶员' : securityUser.type }}:</span>
              <span class="detail-value">{{ securityUser.name }} {{ securityUser.phone || '' }}</span>
            </div>
          </template>
          <div v-else class="detail-item">
            <span class="detail-label">人员信息:</span>
            <span class="detail-value">暂无数据</span>
          </div>
        </div>
        <!-- 车速和驾驶模式 -->
        <div class="info-section info-section-status">
          <div class="speed-display">
            <span class="speed-value">
              {{ testingVehicleInfo?.speed? testingVehicleInfo?.speed: 0 }}
              <span class="speed-unit">km/h</span>
            </span>
          </div>
<!--          <div class="driving-mode">-->
<!--            <span class="mode-value" :class="{ 'mode-auto': testingVehicleInfo?.drivingMode === '自动', 'mode-manual': testingVehicleInfo?.drivingMode === '手动' }">-->
<!--              {{ testingVehicleInfo?.drivingMode }}-->
<!--            </span>-->
<!--          </div>-->
          <div class="driving-mode">
            <span class="mode-value" :class="getDrivingModeClass(testingVehicleInfo?.drivingMode)">
              {{ getDrivingModeText(testingVehicleInfo?.drivingMode) }}
            </span>
          </div>
        </div>
      </div>

      <div class="vehicle-video-top-right">
        <div class="video-list">
          <!-- 前视视频 -->
          <div class="video-item">
            <div class="video-thumbnail">
              <video ref="frontVideoRef" class="video-image" controls muted></video>
              <div class="camera-label">前</div>
            </div>
          </div>
          <!-- 左视视频 -->
          <div class="video-item">
            <div class="video-thumbnail">
              <video ref="leftVideoRef" class="video-image" controls muted></video>
              <div class="camera-label">左</div>
            </div>
          </div>
          <!-- 右视视频 -->
          <div class="video-item">
            <div class="video-thumbnail">
              <video ref="rightVideoRef" class="video-image" controls muted></video>
              <div class="camera-label">右</div>
            </div>
          </div>
          <!-- 后视视频 -->
          <div class="video-item">
            <div class="video-thumbnail">
              <video ref="backVideoRef" class="video-image" controls muted></video>
              <div class="camera-label">后</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import flvjs from 'flv.js';
import AMapLoader from '@amap/amap-jsapi-loader';
import carSelect from '@/assets/images/wcar_select.png';
import { getStartPlay } from '@/api/video';
import { getVehicleBusinessOrders } from '@/api/business/vehicleBusiness';
import { getVehicleInfo } from '@/api/vehicle';


const router = useRouter();

// 获取驾驶模式文本
const getDrivingModeText = (drivingMode) => {
  switch (drivingMode) {
    case 0:
      return '自动';
    case 1:
      return '人工';
    case 2:
      return '遥控';
    default:
      return '自动';
  }
};

// 获取驾驶模式CSS类名
const getDrivingModeClass = (drivingMode) => {
  switch (drivingMode) {
    case 0:
      return 'mode-auto';
    case 1:
    case 2:
      return 'mode-manual'; // 人工和遥控使用同样的样式
    default:
      return 'mode-auto';
  }
};

// 获取URL参数
const getUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    vehicleId: params.get('vehicleId')
  };
};

// 设置页面标题
const setPageTitle = () => {
  document.title = `车辆测试详情`;
};

// 地图相关引用
const mapContainer = ref(null);
const map = ref(null);
const polylines = ref([]);
const carMarker = ref(null); // 小车标记引用

// 车辆数据
const testingVehicleInfo = ref({});

// 车速更新定时器
const speedUpdateTimer = ref(null);

// WebSocket相关状态
const ws = ref(null);
const wsConnected = ref(false);
const wsUrl = ref(''); // WebSocket服务器地址
const reconnectTimeout = ref(null);
const reconnectInterval = 5000; // 重连间隔时间（毫秒）
const maxReconnectAttempts = 5; // 最大重连尝试次数
const reconnectAttempts = ref(0);

// 车辆数据
const testingRoutesInfo = ref([]);

// 业务订单途经点数据
const businessOrders = ref([]);

// 控制路线详情展开/收起的状态变量
const isRouteDetailsExpanded = ref(true);

const getVideoPlayUrl = (vid, position) => {
  return new Promise((resolve, reject) => {
    const param = {
      vehicleId: vid,
      position: position
    };
    getStartPlay(param).then(res => {
      if (res.code === 200) {
        resolve(res.data);
      } else {
        resolve('');
      }
    }).catch(error => {
      console.error('获取播放地址失败:', error);
      resolve('');
    });
  });
};

// 视频元素引用
const frontVideoRef = ref(null);
const leftVideoRef = ref(null);
const rightVideoRef = ref(null);
const backVideoRef = ref(null);

// 播放器实例
const frontPlayer = ref(null);
const leftPlayer = ref(null);
const rightPlayer = ref(null);
const backPlayer = ref(null);

// 视频加载重试状态
const videoRetryCounts = ref({
  front: 0,
  left: 0,
  right: 0,
  back: 0
});
const maxRetryCount = 3;

// 切换路线详情展开/收起状态
const toggleRouteDetails = () => {
  isRouteDetailsExpanded.value = !isRouteDetailsExpanded.value;
};

// 初始化单个视频播放器（带重试机制）
const initVideoPlayer = async (videoElement, url, position) => {
  console.log("initVideoPlayer", position, url);
  
  // 确保视频元素存在
  if (!videoElement) {
    console.warn(`${position}视频元素未准备好，等待DOM更新`);
    await nextTick();
    if (!videoElement) {
      console.error(`${position}视频元素仍然未准备好`);
      return null;
    }
  }
  
  // 确保URL有效
  if (!url) {
    console.error(`${position}视频地址为空`);
    // 尝试重试
    await handleVideoRetry(position);
    return null;
  }
  
  if (flvjs.isSupported()) {
    try {
      const player = flvjs.createPlayer({
        type: 'flv',
        isLive: true,
        url: url,
        cors: true,
        hasAudio: false,
        hasVideo: true,
        headers: {
          'Referer': window.location.origin
        }
      }, {
        enableWorker: false,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: true,
        lazyLoadMaxDuration: 3,
        autoCleanupSourceBuffer: true,
        fixAudioTimestampGap: true,
        isLive: true,
        referrerPolicy: 'no-referrer-when-downgrade'
      });
      
      // 播放状态标记，用于避免重复播放
      let playTriggered = false;
      
      // 添加错误事件监听
      player.on(flvjs.Events.ERROR, (errorType, errorDetail) => {
        console.error(`${position}视频播放出错:`, errorType, errorDetail);
        // 尝试重试
        handleVideoRetry(position);
      });
      
      player.on(flvjs.Events.LOADING_COMPLETE, () => {
        console.log(`${position}视频加载完成`);
        videoRetryCounts.value[position] = 0;
      });
      
      // 添加 MEDIA_INFO 事件，获取到媒体信息后尝试播放
      player.on(flvjs.Events.MEDIA_INFO, () => {
        console.log(`${position}获取到媒体信息`);
        if (!playTriggered && player) {
          playTriggered = true;
          triggerVideoPlay(player, position);
        }
      });

      // 添加 FIRST_FRAME_RENDERED 事件，确保第一帧渲染后播放状态正常
      player.on(flvjs.Events.FIRST_FRAME_RENDERED, () => {
        console.log(`${position}第一帧已渲染`);
        videoRetryCounts.value[position] = 0;
      });

      // 添加 CAN_PLAY 事件
      player.on(flvjs.Events.CAN_PLAY, () => {
        console.log(`${position}视频可以播放`);
        if (!playTriggered && player) {
          playTriggered = true;
          triggerVideoPlay(player, position);
        }
      });
      
      player.attachMediaElement(videoElement);
      player.load();
      
      // 立即尝试播放，同时等待事件触发
      playTriggered = true;
      triggerVideoPlay(player, position);
      
      return player;
    } catch (error) {
      console.error(`${position}创建播放器失败:`, error);
      handleVideoRetry(position);
      return null;
    }
  }
  return null;
};

// 触发视频播放的辅助函数
const triggerVideoPlay = (player, position) => {
  if (!player) return;
  
  player.play().then(() => {
    console.log(`${position}视频播放成功`);
    videoRetryCounts.value[position] = 0;
  }).catch(err => {
    console.warn(`${position}视频播放失败:`, err);
    // 第一次重试
    setTimeout(() => {
      if (player) {
        player.play().catch(e => {
          console.error(`${position}第一次重试播放失败:`, e);
          // 触发重试机制
          handleVideoRetry(position);
        });
      }
    }, 1000);
  });
};

// 处理视频重试
const handleVideoRetry = async (position) => {
  if (videoRetryCounts.value[position] >= maxRetryCount) {
    console.error(`${position}视频已达到最大重试次数，停止重试`);
    return;
  }
  
  videoRetryCounts.value[position]++;
  console.log(`${position}视频第 ${videoRetryCounts.value[position]} 次重试...`);
  
  // 等待一段时间后重试
  await new Promise(resolve => setTimeout(resolve, 2000 * videoRetryCounts.value[position]));
  
  // 获取最新的视频URL并重新初始化
  if (testingVehicleInfo.value.vehicleId) {
    const videoUrl = await getVideoPlayUrl(testingVehicleInfo.value.vehicleId, position);
    const videoRef = {
      front: frontVideoRef.value,
      left: leftVideoRef.value,
      right: rightVideoRef.value,
      back: backVideoRef.value
    }[position];
    
    // 销毁旧播放器
    const playerRef = {
      front: frontPlayer,
      left: leftPlayer,
      right: rightPlayer,
      back: backPlayer
    }[position];
    
    if (playerRef.value) {
      try {
        playerRef.value.pause();
        playerRef.value.unload();
        playerRef.value.detachMediaElement();
        playerRef.value.destroy();
      } catch (e) {
        console.warn(`销毁${position}旧播放器时出错:`, e);
      }
      playerRef.value = null;
    }
    
    // 等待DOM释放
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // 重新初始化
    playerRef.value = await initVideoPlayer(videoRef, videoUrl, position);
  }
};

// 初始化视频播放器
const initVideoPlayers = async () => {
  await nextTick();
  
  // 重置重试计数
  videoRetryCounts.value = {
    front: 0,
    left: 0,
    right: 0,
    back: 0
  };
  
  // 销毁旧的播放器实例
  if (frontPlayer.value) {
    try {
      frontPlayer.value.pause();
      frontPlayer.value.unload();
      frontPlayer.value.detachMediaElement();
      frontPlayer.value.destroy();
    } catch (e) {
      console.warn('销毁前视旧播放器时出错:', e);
    }
    frontPlayer.value = null;
  }
  if (leftPlayer.value) {
    try {
      leftPlayer.value.pause();
      leftPlayer.value.unload();
      leftPlayer.value.detachMediaElement();
      leftPlayer.value.destroy();
    } catch (e) {
      console.warn('销毁左视旧播放器时出错:', e);
    }
    leftPlayer.value = null;
  }
  if (rightPlayer.value) {
    try {
      rightPlayer.value.pause();
      rightPlayer.value.unload();
      rightPlayer.value.detachMediaElement();
      rightPlayer.value.destroy();
    } catch (e) {
      console.warn('销毁右视旧播放器时出错:', e);
    }
    rightPlayer.value = null;
  }
  if (backPlayer.value) {
    try {
      backPlayer.value.pause();
      backPlayer.value.unload();
      backPlayer.value.detachMediaElement();
      backPlayer.value.destroy();
    } catch (e) {
      console.warn('销毁后视旧播放器时出错:', e);
    }
    backPlayer.value = null;
  }
  
  // 确保车辆ID存在
  if (!testingVehicleInfo.value.vehicleId) {
    console.error('车辆ID不存在，无法获取视频播放地址');
    return;
  }
  
  // 等待DOM稳定
  await new Promise(resolve => setTimeout(resolve, 100));
  
  // 初始化新的播放器实例
  // 使用 getVideoPlayUrl 方法获取视频地址
  try {
    const [frontVideoUrl, leftVideoUrl, rightVideoUrl, backVideoUrl] = await Promise.all([
      getVideoPlayUrl(testingVehicleInfo.value.vehicleId, 'front'),
      getVideoPlayUrl(testingVehicleInfo.value.vehicleId, 'left'),
      getVideoPlayUrl(testingVehicleInfo.value.vehicleId, 'right'),
      getVideoPlayUrl(testingVehicleInfo.value.vehicleId, 'back')
    ]);
    
    // 并行初始化所有播放器
    frontPlayer.value = await initVideoPlayer(frontVideoRef.value, frontVideoUrl, 'front');
    leftPlayer.value = await initVideoPlayer(leftVideoRef.value, leftVideoUrl, 'left');
    rightPlayer.value = await initVideoPlayer(rightVideoRef.value, rightVideoUrl, 'right');
    backPlayer.value = await initVideoPlayer(backVideoRef.value, backVideoUrl, 'back');
  } catch (error) {
    console.error('获取视频播放地址失败:', error);
  }
};

// 初始化地图
const initMap = () => {
  if (!mapContainer.value || !window.AMap) return;

  // 创建地图实例，使用默认中心坐标
  map.value = new window.AMap.Map(mapContainer.value, {
    zoom: 12,
    center: [103.76, 36.55], // 默认中心坐标
    mapStyle: 'amap://styles/navi' // 使用导航地图风格
  });

  // 只有当有位置数据时才创建车辆标记
  if (!carMarker.value && testingVehicleInfo.value.location) {
    carMarker.value = new window.AMap.Marker({
      position: testingVehicleInfo.value.location,
      icon: new window.AMap.Icon({
        size: new window.AMap.Size(32, 32),
        image: require('@/assets/images/wcar_select.png'),
        imageSize: new window.AMap.Size(32, 32)
      }),
      anchor: 'center', // 设置锚点为图标中心
      title: testingVehicleInfo.value.licenceNo || '测试车辆',
      zIndex: 1000
    });
    // 添加标记到地图
    carMarker.value.setMap(map.value);
  }

  console.log('地图初始化完成');
};

// 解析导航数据中的路线坐标
const parseRouteCoordinates = () => {
  if (!testingRoutesInfo.value || !testingRoutesInfo.value[0] || !testingRoutesInfo.value[0].paths) return [];
  
  const allCoordinates = [];

  testingRoutesInfo.value[0].paths.forEach(paths => {
    if (paths.paths) {
      const routeCoordinates = [];
      // 遍历当前子路线的所有路径段
      paths.paths.forEach(path => {
        if (path.polyline && Array.isArray(path.polyline)) {
          // 每个polyline包含多个坐标点对 [lng, lat]
          routeCoordinates.push(...path.polyline);
        }
      });
      if (routeCoordinates.length > 0) {
        allCoordinates.push(routeCoordinates);
      }
    }
  });
  
  return allCoordinates;
};

// 获取车辆业务订单数据
const fetchBusinessOrders = async (vehicleId) => {
  try {
    const response = await getVehicleBusinessOrders(vehicleId);
    if (response.code === 200 && response.data) {
      businessOrders.value = response.data;
    }
  } catch (error) {
    console.error('获取车辆业务订单数据失败:', error);
    businessOrders.value = [];
  }
};

// 绘制车辆路线
const drawVehicleRoute = () => {
  if (!map.value || !window.AMap) return;

  // 清除之前的路线
  if (polylines.value && polylines.value.length > 0) {
    map.value.remove(polylines.value);
    polylines.value = [];
  }

  const allRouteCoordinates = parseRouteCoordinates();
  
  if (allRouteCoordinates.length === 0) return;

  allRouteCoordinates.forEach((routeCoordinates, index) => {
    if (routeCoordinates.length === 0) return;
    
    // 创建导航样式的路线
    const polyline = new window.AMap.Polyline({
      path: routeCoordinates,
      strokeColor: '#3366FF', // 路线标记颜色
      strokeWeight: 5,        // 线条粗细
      strokeOpacity: 1,
      strokeStyle: 'solid', // 实线
      showDir: true,
      lineJoin: 'round',
      lineCap: 'round',
      zIndex: 100
    });

    // 添加路线到地图
    polylines.value.push(polyline);
    map.value.add(polyline);
  });
  
  // 如果有子路线，添加主路线的起点、终点和小车标记
  if (allRouteCoordinates.length > 0) {
    // 设置第一条路线是主路线
    const mainRouteCoordinates = allRouteCoordinates[0];
    
    // 添加起点标记
    const startMarker = new window.AMap.Marker({
      position: mainRouteCoordinates[0],
      icon: new window.AMap.Icon({
        size: new window.AMap.Size(30, 30),
        image: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
        anchor: new window.AMap.Pixel(15, 30) // 设置锚点为图标底部中心点(30/2, 30)
      }),
      zIndex: 101
    });
    
    // 添加终点标记
    const endMarker = new window.AMap.Marker({
      position: mainRouteCoordinates[mainRouteCoordinates.length - 1],
      icon: new window.AMap.Icon({
        size: new window.AMap.Size(30, 30),
        image: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
        anchor: new window.AMap.Pixel(15, 30) // 设置锚点为图标底部中心点(30/2, 30)
      }),
      zIndex: 101
    });
    
    // 创建小车标记（使用自定义HTML内容实现旋转效果）
    if (!carMarker.value && window.AMap) {
      // 创建自定义HTML内容
      const carContent = document.createElement('div');
      carContent.style.width = '36px';
      carContent.style.height = '36px';
      carContent.style.display = 'flex';
      carContent.style.justifyContent = 'center';
      carContent.style.alignItems = 'center';
      
      // 创建小车图片元素
      const carImg = document.createElement('img');
      carImg.src = carSelect;
      carImg.style.width = '36px';
      carImg.style.height = '36px';
      carImg.style.transformOrigin = 'center center'; // 设置旋转中心点
      // 默认旋转角度为0度（正北方向）
      carImg.style.transform = 'rotate(0deg)';
      carImg.style.webkitTransform = 'rotate(0deg)';
      carImg.style.mozTransform = 'rotate(0deg)';
      carImg.style.msTransform = 'rotate(0deg)';
      
      carContent.appendChild(carImg);
      
      carMarker.value = new window.AMap.Marker({
        position: mainRouteCoordinates[0],       // 初始位置在主路线起点
        content: carContent,                     // 使用自定义HTML内容
        anchor: 'center',                        // 锚点设置为中心点
        zIndex: 102 // 确保小车在路线和标记之上
      });
      
      // 保存对图片元素的引用，以便后续直接操作
      carMarker.value.carImgElement = carImg;
      map.value.add(carMarker.value);
    }
    
    map.value.add(startMarker);
    map.value.add(endMarker);
    
    polylines.value.push(startMarker, endMarker);
  }

  // 添加途经点标记
  console.log('绘制途经点前的testingRoutesInfo:', testingRoutesInfo.value);
  if (testingRoutesInfo.value && Array.isArray(testingRoutesInfo.value)) {
    testingRoutesInfo.value.forEach((route, routeIndex) => {
      console.log(`路线${routeIndex}的waypoints:`, route.waypoints);
      if (route.waypoints && Array.isArray(route.waypoints)) {
        route.waypoints.forEach((waypoint, waypointIndex) => {
          console.log(`途经点${waypointIndex}数据:`, waypoint);
          // 检查location格式是否正确
          const hasValidLocation = waypoint.location && (Array.isArray(waypoint.location) && waypoint.location.length === 2 || typeof waypoint.location === 'string');
          
          if (hasValidLocation) {
            let position = waypoint.location;
            // 如果是字符串格式，转换为数组
            if (typeof position === 'string') {
              position = position.split(',').map(coord => parseFloat(coord));
            }
            
            // 确保转换后的坐标有效
            if (Array.isArray(position) && position.length === 2 && !isNaN(position[0]) && !isNaN(position[1])) {
              // 创建自定义HTML内容，参考index.vue的车辆标记样式
              const content = document.createElement('div');
              content.style.display = 'flex';
              content.style.alignItems = 'center';
              content.style.width = 'auto';
              content.style.verticalAlign = 'top';
              
              // 创建红色圆形途经点图标
              const iconElement = document.createElement('div');
              iconElement.style.width = '16px';
              iconElement.style.height = '16px';
              iconElement.style.borderRadius = '50%';
              iconElement.style.backgroundColor = '#FF0000';
              iconElement.style.border = '2px solid #FFFFFF';
              iconElement.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
              iconElement.style.marginRight = '6px';
              
              // 创建途经点名称显示区域
              const labelElement = document.createElement('div');
              labelElement.style.background = 'white';
              labelElement.style.padding = '4px 8px';
              labelElement.style.borderRadius = '4px';
              labelElement.style.fontSize = '12px';
              labelElement.style.whiteSpace = 'nowrap';
              labelElement.style.border = 'none';
              labelElement.style.outline = 'none';
              labelElement.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.2)';
              labelElement.style.margin = '0px';
              labelElement.style.verticalAlign = 'top';
              labelElement.style.lineHeight = 'normal';
              labelElement.style.color = '#303133';
              labelElement.textContent = waypoint.name || `途经点${waypointIndex + 1}`;
              
              // 将图标和标签添加到容器
              content.appendChild(iconElement);
              content.appendChild(labelElement);
              
              // 创建标记，参考index.vue的车辆标记实现
              const waypointMarker = new window.AMap.Marker({
                position: position,
                title: waypoint.name || `途经点${waypointIndex + 1}`,
                map: map.value,
                content: content, // 使用自定义HTML内容
                offset: new window.AMap.Pixel(-9, -9), // 水平和垂直各偏移-9px，使红色圆点中心点对准经纬度位置
                zIndex: 101 // 与起点终点标记保持相同层级
              });
              
              // 添加途经点标记到地图
              map.value.add(waypointMarker);
              polylines.value.push(waypointMarker);
              console.log(`成功添加途经点${waypointIndex}:`, waypoint.name, position);
            } else {
              console.warn(`途经点${waypointIndex}的坐标格式无效:`, waypoint.location);
            }
          } else {
            console.warn(`途经点${waypointIndex}缺少有效坐标:`, waypoint);
          }
        });
      }
    });
  } else {
    console.warn('testingRoutesInfo不是有效的数组:', testingRoutesInfo.value);
  }

  // 确保所有元素都已添加到地图
  if (polylines.value.length > 0 && map.value) {
    // 使用setTimeout确保所有路线和标记都已完全渲染到地图上
    setTimeout(() => {
      // 首先尝试使用setFitView聚焦到所有路线和标记
      try {
        map.value.setFitView(polylines.value, {
          padding: [50, 50, 50, 50],
          duration: 800
        });
      } catch (error) {
        console.error('setFitView调用失败，尝试手动设置地图视图:', error);
        
        // 如果setFitView失败，手动计算并设置地图中心点和缩放级别
        if (allRouteCoordinates.length > 0 && allRouteCoordinates[0].length > 0) {
          // 使用第一条路线的中点作为地图中心点
          const route = allRouteCoordinates[0];
          const midIndex = Math.floor(route.length / 2);
          const center = route[midIndex];
          
          // 设置地图中心点和缩放级别
          map.value.setCenter(center);
          map.value.setZoom(14);
        }
      }
    }, 100);
  }

  console.log('绘制车辆路线:', testingVehicleInfo.value.licenceNo, '路线数量:', allRouteCoordinates.length);
};

const goBack = () => {
  router.back()
};

// 生成WebSocket连接ID
const generateWebSocketId = (vehicleVin) => {
  // 使用车辆ID、当前时间戳和随机数生成唯一ID
  return `vehicle_${vehicleVin}_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
};

// 处理车辆数据更新
const handleVehicleDataUpdate = (data) => {
  if (!data || !data.vehicleId) {
    console.warn('无效的车辆数据:', data);
    return;
  }

  // 如果当前推送的车辆是当前页面的车辆，更新其数据
  if (testingVehicleInfo.value.vehicleId === data.vehicleId) {
    testingVehicleInfo.value.licenceNo = data.licenceNo || testingVehicleInfo.value.licenceNo;
    testingVehicleInfo.value.vehicleId = data.vehicleId || testingVehicleInfo.value.vehicleId;
    testingVehicleInfo.value.vehicleVin = data.vehicleVin || testingVehicleInfo.value.vehicleVin;
    
    // 更新车辆信息
    testingVehicleInfo.value.status = data.status || testingVehicleInfo.value.status;
    testingVehicleInfo.value.speed = data.speed || testingVehicleInfo.value.speed;
    // 使用严格判断
    if (data.drivingMode !== undefined && data.drivingMode !== null) {
      testingVehicleInfo.value.drivingMode = data.drivingMode;
    }
    // 更新电量信息
    if (data.batteryLevel !== undefined && data.batteryLevel !== null) {
      testingVehicleInfo.value.batteryLevel = data.batteryLevel;
    }
    // 如果有位置信息，更新车辆位置和地图标记
    if (data.location) {
      testingVehicleInfo.value.location = data.location;
      
      // 如果车辆标记不存在，创建新的标记
      if (!carMarker.value && map.value) {
        // 创建自定义图标内容
        const iconContent = document.createElement('div');
        iconContent.style.position = 'relative';
        iconContent.style.width = '32px';
        iconContent.style.height = '32px';
        
        // 创建车辆图标
        const imgElement = document.createElement('img');
        imgElement.src = require('@/assets/images/wcar_select.png');
        imgElement.style.width = '32px';
        imgElement.style.height = '32px';
        imgElement.style.objectFit = 'contain';
        
        // 设置旋转角度：angle + 150
        if (data.angle !== undefined && data.angle !== null) {
          imgElement.style.transform = `rotate(${data.angle + 150}deg)`;
          imgElement.style.transformOrigin = 'center center';
        }
        
        iconContent.appendChild(imgElement);
        
        carMarker.value = new window.AMap.Marker({
          position: data.location,
          content: iconContent, // 使用自定义HTML内容
          anchor: 'center', // 设置锚点为图标中心
          title: testingVehicleInfo.value.licenceNo || '测试车辆',
          zIndex: 1000
        });
        
        // 添加标记到地图
        carMarker.value.setMap(map.value);
      } else if (carMarker.value) {
        // 更新地图上的车辆标记位置
        carMarker.value.setPosition(data.location);
        
        // 更新旋转角度
        const content = carMarker.value.getContent();
        if (content) {
          const imgElement = content.querySelector('img');
          if (imgElement && data.angle !== undefined && data.angle !== null) {
            imgElement.style.transform = `rotate(${data.angle + 150}deg)`;
            imgElement.style.transformOrigin = 'center center';
          }
        }
      }
      
      // 移动地图中心到车辆位置
      if (map.value) {
        map.value.setCenter(data.location);
      }
    }
  }
};

// 尝试重新连接WebSocket
const attemptReconnect = () => {
  if (reconnectAttempts.value >= maxReconnectAttempts) {
    console.error('达到最大重连尝试次数，停止重连');
    return;
  }

  clearTimeout(reconnectTimeout.value);
  reconnectTimeout.value = setTimeout(() => {
    reconnectAttempts.value++;
    console.log(`尝试重新连接WebSocket (${reconnectAttempts.value}/${maxReconnectAttempts})`);
    initWebSocket();
  }, reconnectInterval);
};

// 关闭WebSocket连接
const closeWebSocket = () => {
  clearTimeout(reconnectTimeout.value);
  if (ws.value) {
    ws.value.close();
    ws.value = null;
  }
};

// 初始化WebSocket连接
const initWebSocket = () => {
  if (ws.value) {
    ws.value.close();
  }

  try {
    // 获取当前车辆ID
    const vehicleVin = testingVehicleInfo.value?.vehicleVin;
    
    // 生成唯一的WebSocket连接ID，包含车辆ID
    const wsId = generateWebSocketId(vehicleVin);

    // 根据环境变量构建WebSocket连接URL
    let url = "";
    console.log(process.env, process.env.VUE_APP_WS_URL);
    if (process.env.VUE_APP_ENV === "development") {
      console.log(window.location);
      url = process.env.VUE_APP_WS_URL + "/ws/" + wsId;
    } else {
      url = "wss://" + window.location.host + "/ws/" + wsId;
    }

    wsUrl.value = url;
    ws.value = new WebSocket(url);
    wsConnected.value = false;

    // 连接建立事件
    ws.value.onopen = () => {
      console.log('WebSocket连接已建立');
      wsConnected.value = true;
      reconnectAttempts.value = 0;
    };

    // 接收消息事件
    ws.value.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('接收到消息事件', data);
        handleVehicleDataUpdate(data);
      } catch (error) {
        console.error('解析WebSocket消息失败:', error);
      }
    };

    // 错误事件
    ws.value.onerror = (error) => {
      console.error('WebSocket错误:', error);
      wsConnected.value = false;
    };

    // 连接关闭事件
    ws.value.onclose = (event) => {
      console.log('WebSocket连接已关闭:', event.code, event.reason);
      wsConnected.value = false;
      attemptReconnect();
    };
  } catch (error) {
    console.error('创建WebSocket连接失败:', error);
    attemptReconnect();
  }
};

onMounted(async () => {
  try {
    setPageTitle();
    
    const urlParams = getUrlParams();
    const vehicleId = urlParams.vehicleId;
    
    await AMapLoader.load({
      key: '6588d9e5b6ae0751c799cb4c7b3e30be',
      version: '2.0',
      plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.Geolocation']
    });
    
    initMap();
    
    if (vehicleId) {
      const vehicleInfoRes = await getVehicleInfo(vehicleId);
      
      if (vehicleInfoRes && vehicleInfoRes.data) {
        testingVehicleInfo.value = vehicleInfoRes.data;
        
        if (vehicleInfoRes.data.vehicleId) {
          await fetchBusinessOrders(vehicleInfoRes.data.vehicleId);
        }
      }
    }
    
    await initVideoPlayers();
    
    initWebSocket();
  } catch (error) {
    console.error('页面初始化失败:', error);
  }
});

onUnmounted(() => {
  // 清除地图实例
  if (map.value) {
    map.value.destroy();
    map.value = null;
  }
  

  
  // 清除车速更新定时器，因为现在使用 WebSocket 推送的实时速度
  if (speedUpdateTimer.value) {
    clearInterval(speedUpdateTimer.value);
    speedUpdateTimer.value = null;
  }
  
  // 关闭WebSocket连接
  closeWebSocket();
  
  // 移除事件监听
  window.removeEventListener('AMapLoaded', initMap);
  
  // 销毁视频播放器实例
  if (frontPlayer.value) {
    frontPlayer.value.pause();
    frontPlayer.value.unload();
    frontPlayer.value.detachMediaElement();
    frontPlayer.value.destroy();
    frontPlayer.value = null;
  }
  if (leftPlayer.value) {
    leftPlayer.value.pause();
    leftPlayer.value.unload();
    leftPlayer.value.detachMediaElement();
    leftPlayer.value.destroy();
    leftPlayer.value = null;
  }
  if (rightPlayer.value) {
    rightPlayer.value.pause();
    rightPlayer.value.unload();
    rightPlayer.value.detachMediaElement();
    rightPlayer.value.destroy();
    rightPlayer.value = null;
  }
  if (backPlayer.value) {
    backPlayer.value.pause();
    backPlayer.value.unload();
    backPlayer.value.detachMediaElement();
    backPlayer.value.destroy();
    backPlayer.value = null;
  }
});
</script>

<style scoped>
.vehicle-detail-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-wrapper {
  width: 100%;
  height: 100%;
}

/* 地图右上角的视频列表区域 */
.vehicle-video-top-right {
  position: absolute;
  top: 230px;
  right: 12px;
  z-index: 10;
  background-color: transparent;
  border-radius: 8px;
  width: 330px;
  padding: 12px;
}

.video-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f0f0f0;
}

.video-thumbnail {
  position: relative;
  width: 100%;
  height: 160px;
  overflow: hidden;
}

.video-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.camera-label {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.vehicle-testing-detail {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  width: 370px;
  max-height: 600px;
}

.route-info-panel {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 12px;
  height: 100%; /* 填充整个容器 */
  display: flex;
  flex-direction: column;
  position: relative;
}

.panel-close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 20px;
  color: #999999;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.panel-close-btn:hover {
  background-color: #f5f5f5;
  color: #666666;
}

.route-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
}

.arrow-section {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.points-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 55px;
}

.point-item {
  display: flex;
  align-items: center;
}

.point-label {
  background-color: #3366FF;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  min-width: 20px;
  text-align: center;
}

.point-name {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.route-arrow {
  color: #ff6b35;
  font-size: 16px;
  font-weight: bold;
}

.route-duration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.duration-label {
  font-size: 12px;
  color: #666666;
}

.duration-value {
  font-size: 16px;
  font-weight: 600;
  color: #ff6b35;
}

.route-details {
  margin-top: 7px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
  flex: 1;
  max-height: calc(100% - 120px);
  overflow-y: auto;
}

/* 统计信息样式 */
.events-stats {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 12px;
}

.stat-item {
  display: flex;
  align-items: center;
}

.stat-label {
  color: #666;
  margin-right: 4px;
}

/* 事件列表样式 */
.events-list {
  position: relative;
  padding-left: 20px;
}

.event-item {
  display: flex;
  margin-bottom: 16px;
  position: relative;
}

.event-timeline {
  position: absolute;
  left: -20px;
  top: 0;
  width: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  z-index: 1;
}

.timeline-line {
  width: 2px;
  height: calc(100% - 8px);
  background-color: #e9ecef;
  margin-top: 4px;
}

.event-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.event-time {
  font-size: 12px;
  color: #666;
  margin-right: 12px;
  min-width: 70px;
}

.event-description {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  flex: 1;
}

.event-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.event-stop-name {
  font-size: 14px;
  color: #333;
}

.event-status {
  font-size: 12px;
  color: #1890ff;
  padding: 2px 8px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 4px;
}

.route-info-panel::-webkit-scrollbar {
  width: 6px;
}

.route-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.route-info-panel::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.route-info-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.vehicle-info-top-right {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 320px;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.route-header {
  border-radius: 8px;
}

.info-section {
  background-color: transparent;
  padding: 12px;
}

.info-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}

.license-plate-highlight {
  padding: 6px 12px;
  border-radius: 4px;
}

.license-number {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.battery-display {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.battery-icon {
  font-size: 14px;
  margin-right: 4px;
}

.battery-value {
  font-size: 14px;
  font-weight: bold;
  color: #52c41a;
}

.back-button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.back-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.info-section-details {
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-right: 16px;
  white-space: normal;
  margin-bottom: 8px;
}

.detail-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  margin-right: 6px;
  text-align: right;
  width: 80px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 13px;
  color: #303133;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.info-section-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.speed-display {
  text-align: center;
}

.speed-value {
  font-size: 24px;
  font-weight: bold;
  color: #dc3545;
}

.speed-unit {
  font-size: 12px;
  font-weight: normal;
  color: #000;
  margin-left: 4px;
}

.driving-mode {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mode-value {
  font-size: 14px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
}

.mode-auto {
  background-color: #28a745;
  color: white;
}

.mode-manual {
  background-color: #fd7e14;
  color: white;
}
</style>